module.exports = __webpack_public_path__ + "static/media/YB5F16_0.0e058fb5.jpg";